<template>
  <b-tag
    v-if="isTranslated || hasVerifiedTranslation"
    class="ml-1"
    :class="[showLabel ? 'px-4' : '']"
    rounded
    :style="{
      color: showLabel ? 'white' : color,
      backgroundColor: showLabel ? color : 'transparent',
    }"
  >
    <span>
      <i slot="icon" class="pr-1">
        <IconTranslate class="icon is-small" size="10" />
      </i>
      <span v-if="showLabel">
        {{ hasVerifiedTranslation ? "Translation Verified" : "Translated" }}
      </span>
    </span>
  </b-tag>
</template>

<script>
import IconTranslate from "@/components/icons/IconTranslate.vue";
import helpers from "@/helpers";

export default {
  name: "ServiceTranslationTag",
  components: { IconTranslate },
  props: {
    language: String,
    formItineraryService: Object,
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    color() {
      return this.hasVerifiedTranslation ? "green" : "#1D3B83";
    },
    translatableAttributes() {
      return helpers.translatableAttributes(
        this.language,
        this.formItineraryService,
        ["name", "description"]
      );
    },
    isTranslated() {
      return helpers.checkTranslationStatus(this.translatableAttributes, 2);
    },
    hasVerifiedTranslation() {
      return helpers.checkTranslationStatus(this.translatableAttributes, 3);
    },
  },
};
</script>
